import { NgClass, UpperCasePipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import {
    ApplyPipe,
    ButtonComponent,
    DeltaViewComponent,
    IconButtonComponent,
} from '@interacta-shared/ui';
import { IconComponent } from '@interacta-shared/ui-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { ProTipData, TipActionCallback } from '../../models/tip.model';
import { asDelta, asString } from '../../models/tip.utils';

@Component({
    imports: [
        TranslatePipe,
        IconComponent,
        IconButtonComponent,
        ButtonComponent,
        DeltaViewComponent,
        ApplyPipe,
        UpperCasePipe,
        NgClass,
    ],
    selector: 'interacta-pro-tip',
    templateUrl: './pro-tip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProTipComponent<A, P> {
    readonly tip = input.required<ProTipData<A, P> | null>();
    readonly closeTip = output<void>();
    readonly actionClicked = output<TipActionCallback<A>>();

    readonly imageSrc = computed(() => {
        const tip = this.tip();
        return tip && tip.image !== 'empty'
            ? `assets/shared/images/pro-tip/${tip.image}.png`
            : null;
    });

    readonly hasCTAs = computed(() => !!this.tip()?.actionCallbacks.length);

    readonly asString = asString;
    readonly asDelta = asDelta;
}
